import { getAllProjectLinks } from '@api/services/project-link.service';
import useDataQuery from '@hooks/use-data-query';

const useLinkListData = (clientId: string, projectId: string) => {
    const linkList = useDataQuery(['clients', clientId, 'projects', projectId, 'links'], () =>
        getAllProjectLinks(clientId, projectId)
    );
    return {
        links: linkList.data,
        isLoading: linkList.isLoading,
    };
};

export default useLinkListData;
